import * as React from 'react'

import { TermsPage } from 'pages/terms/TermsPage'

export const TermsAsPage: React.FC = () => <TermsPage />
